var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    rx: 2,
    fill: "#000D26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8992 3H7V6.99965C7.82428 6.99965 8.53141 7.50332 8.83359 8.22116C8.9541 8.50742 9.236 8.69114 9.54525 8.69114C9.85452 8.69114 10.1364 8.50742 10.2569 8.22116C10.5591 7.50332 11.2662 6.99965 12.0905 6.99965C13.1897 6.99965 14.0807 7.89525 14.0807 9C14.0807 10.1048 13.1897 11.0003 12.0905 11.0003C11.2662 11.0003 10.5591 10.4967 10.2569 9.77884C10.1364 9.49256 9.85452 9.30883 9.54525 9.30883C9.236 9.30883 8.9541 9.49256 8.83359 9.77884C8.53141 10.4967 7.82428 11.0003 7 11.0003V15H11.8992C15.1961 15 17.8688 12.3137 17.8688 9C17.8688 5.68628 15.1961 3 11.8992 3Z",
    fill: "url(#paint0_radial_2330_43012)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8992 3H7V6.99965C7.82428 6.99965 8.53141 7.50332 8.83359 8.22116C8.9541 8.50742 9.236 8.69114 9.54525 8.69114C9.85452 8.69114 10.1364 8.50742 10.2569 8.22116C10.5591 7.50332 11.2662 6.99965 12.0905 6.99965C13.1897 6.99965 14.0807 7.89525 14.0807 9C14.0807 10.1048 13.1897 11.0003 12.0905 11.0003C11.2662 11.0003 10.5591 10.4967 10.2569 9.77884C10.1364 9.49256 9.85452 9.30883 9.54525 9.30883C9.236 9.30883 8.9541 9.49256 8.83359 9.77884C8.53141 10.4967 7.82428 11.0003 7 11.0003V15H11.8992C15.1961 15 17.8688 12.3137 17.8688 9C17.8688 5.68628 15.1961 3 11.8992 3Z",
    fill: "url(#paint1_radial_2330_43012)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2330_43012",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(7.3229 10.3333 -9.35922 6.65149 8.10234 4.13333)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589342,
    stopColor: "#F7A1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97D5FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2330_43012",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.55491e-07 2.66667 -2.69272 0.00377111 12.1333 9.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245192,
    stopColor: "#000D26",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000D26",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAgent);
export default __webpack_public_path__ + "static/media/card-agent.e3e48e37377139851819a8a2d8d3e462.svg";
export { ForwardRef as ReactComponent };